module.exports = __webpack_public_path__ + "img/icone-ordem-valor-maior.34ac6a2b.svg";